import { toast } from 'sonner';

import store from '@/store';
import { p2pActions } from '@/store/p2p-slice';

import { sendP2PSocketData } from './p2pConnection';

export const requestJoinHandler = (dataRec: {
    connection_id: string;
    device_id?: string;
    user_id: string;
}) => {
    const { connection_id, user_id, device_id } = dataRec;
    const activeServer = store.getState().serverDataReducer.activeServer;
    const waitingList = store.getState().p2pReducer.waitingList;
    const isAdmin =
        store.getState().serverDataReducer.userPermissions?.[activeServer]?.[
            'administrator'
        ];
    const p2pNotificationsMode = store.getState().p2pReducer.notificationMode;

    const membersList =
        store.getState().serverDataReducer.memberList?.[activeServer];

    const openP2pPanel = () => {
        isAdmin &&
            store.dispatch(
                p2pActions.toggleP2PPanel({ state: true, target: device_id }),
            );
    };

    if (!isAdmin) return;
    if (membersList?.[user_id]?.banned) {
        return sendP2PSocketData({
            command: 'send_msg',
            data: {
                client_event: 'not_auth',
                rejected: true,
            },
        });
    }
    if (waitingList?.[device_id]) return;
    if (p2pNotificationsMode === 'GENERAL') {
        toast(
            `User ${membersList?.[user_id]?.name} wants permit to access server.`,
            {
                duration: 2000,
                action: {
                    label: 'check',
                    onClick: openP2pPanel,
                },
            },
        );
    }
    store.dispatch(
        p2pActions.updateWaitingUser({
            ...membersList?.[user_id],
            connection_id,
            user_id,
            device_id,
        }),
    );
};
